import { Theme } from '@mui/material'
import { OrderState, PaymentState } from '../services/api/sharedTypes/Common'
import { EventDto } from '../services/api/sharedTypes/Event'

export const convertStringToOrderState = (data: number) => {
    if (data === OrderState.Finished) return OrderState.Finished
    if (data === OrderState.Asked) return OrderState.Asked
    if (data === OrderState.OfferSent) return OrderState.OfferSent
    if (data === OrderState.Cancelled) return OrderState.Cancelled
    if (data === OrderState.OfferAccepted) return OrderState.OfferAccepted
    if (data === OrderState.CancelledWeather) return OrderState.CancelledWeather
    if (data === OrderState.OfferRejected) return OrderState.OfferRejected
    return OrderState.NotSet
}

export const convertStringToPaymentState = (data: number) => {
    if (data === PaymentState.NotPaid) return PaymentState.NotPaid
    if (data === PaymentState.Paid) return PaymentState.Paid
    if (data === PaymentState.PaidWithoutInvoice) return PaymentState.PaidWithoutInvoice
    if (data === PaymentState.Free) return PaymentState.Free
    return PaymentState.NotSet
}

export const convertOrderStateTypeToString = (data: OrderState) => {
    if (data === OrderState.Finished) return 'Proběhlá'
    if (data === OrderState.Asked) return 'Poptávka'
    if (data === OrderState.OfferSent) return 'Odeslána'
    if (data === OrderState.Cancelled) return 'Zrušená'
    if (data === OrderState.OfferAccepted) return 'Schválená'
    if (data === OrderState.CancelledWeather) return 'Zrušená počasí'
    if (data === OrderState.OfferRejected) return 'Neakceptovaná'
    return 'Není nastaveno'
}

export const convertPaymentStateTypeToString = (data: PaymentState) => {
    if (data === PaymentState.NotPaid) return 'Nezaplaceno'
    if (data === PaymentState.Paid) return 'Zaplaceno'
    if (data === PaymentState.PaidWithoutInvoice) return 'Zaplaceno'
    if (data === PaymentState.Free) return 'Zadarmo'
    return 'Beze stavu'
}

export enum EventTab {
    Table = 'table',
    Planning = 'planning',
}

export const getEventTab = (tab: string) => {
    if (tab === EventTab.Table) return EventTab.Table
    if (tab === EventTab.Planning) return EventTab.Planning
    return EventTab.Table
}

export const getEventTabNumber = (tab: EventTab) => {
    if (tab === EventTab.Table) return 0
    if (tab === EventTab.Planning) return 1
    return 0
}

export const convertNumberToEventTab = (data: number) => {
    if (data === 0) return EventTab.Table
    if (data === 1) return EventTab.Planning
    return EventTab.Table
}

export const getEventTableRowColor = (paymentState: PaymentState, theme: Theme, orderState?: OrderState) => {
    if (orderState && orderState === OrderState.OfferSent) return theme.palette.tableRow?.background.offerSent ?? ''

    if (orderState && orderState === OrderState.OfferAccepted) return theme.palette.tableRow?.background.oderAccepted ?? ''

    if (orderState && orderState === OrderState.Asked) return theme.palette.tableRow?.background.asked ?? ''

    if (paymentState === PaymentState.NotSet) return ''

    if (
        paymentState === PaymentState.Paid ||
        paymentState === PaymentState.PaidWithoutInvoice ||
        paymentState === PaymentState.Free
    )
        return theme.palette.tableRow?.background.paid ?? ''
    else return theme.palette.tableRow?.background.notPaid ?? ''
}

export const getEmptyEventObject: () => EventDto = () => {
    return {
        id: '',
        name: '',
        description: '',
        address: {
            city: '',
            street: '',
            zip: '',
        },
        contactPerson: '',
        contractors: [],
        orderState: OrderState.Asked,
        paymentState: PaymentState.NotSet,
        createdAt: new Date(),
        endsAt: new Date(),
        startsAt: new Date(),
        invoiced: 0,
        lastModifiedAt: new Date(),
        notesForBrigadiers: '',
        orderStateChanges: [],
        paymentStateChanges: [],
        products: [],
        profit: 0,
        revenue: 0,
        costs: 0,
        latitude: 0,
        longitude: 0,
        isEverythingReady: false,
        planningNote: '',
        contactPhones: [],
        hasContactWithEmail: false,
        emailMessagesLogs: [],
        contacts: [{ name: '', phone: '', email: '' }],
    }
}
